import React, { useState } from 'react'

function TeamupCollaboratedCount({
    caseItem,
    userInfo,
    
}) {
    const [showCollaboratedHoverMsg, setShowCollaboratedHoverMsg] = useState(false);
  return (
     <div className="flex gap-2 relative flex-wrap"
        onMouseEnter={() => setShowCollaboratedHoverMsg(true)}
        onMouseLeave={() => setShowCollaboratedHoverMsg(false)}
        >
        {
                caseItem?.connectedCount > 0 && (
            <span className="px-2 py-1 text-[11.5px] font-medium rounded-full text-navy bg-navy/[.05] border border-navy/[.12]">Connected on {caseItem.connectedCount} {caseItem.connectedCount === 1 ? 'case' : 'cases'}</span>
        )
        }
        {
            caseItem?.collaboratorCount > 0 && (
            <span className="px-2 py-1 text-[11.5px] font-medium rounded-full text-success bg-success/[.08] border border-success/[.3]">Closed {caseItem.collaboratorCount} together</span>
        )}
        {
        showCollaboratedHoverMsg && (caseItem?.collaboratorCount > 0 && caseItem?.connectedCount > 0 ?
        <div className='absolute text-xs rounded-md p-2 z-10 top-8 w-60 bg-navy text-ivory shadow-lg'>
            You have closed {caseItem?.collaboratorCount} cases with {userInfo?.isUserFunder ? caseItem?.fromUser.firstName  : caseItem?.toUser.firstName } {userInfo?.isUserFunder ? caseItem?.fromUser.lastName : caseItem?.toUser.lastName}<br/> and have connected on {caseItem?.connectedCount} cases.
        </div>
        :
        caseItem?.collaboratorCount > 0 ?
        <div className='absolute text-xs rounded-md p-2 z-10 top-8 w-60 bg-navy text-ivory shadow-lg'>
            You have closed {caseItem?.collaboratorCount} cases with {userInfo?.isUserFunder ? caseItem?.fromUser.firstName : caseItem?.toUser.firstName} {userInfo?.isUserFunder ? caseItem?.fromUser.lastName : caseItem?.toUser.lastName}.
        </div>
        :
        caseItem?.connectedCount > 0 &&
        <div className='absolute text-xs rounded-md p-2 z-10 top-8 w-60 bg-navy text-ivory shadow-lg'>
            You have connected on {caseItem?.connectedCount} cases with {userInfo?.isUserFunder ? caseItem?.fromUser.firstName : caseItem?.toUser.firstName} {userInfo?.isUserFunder ? caseItem?.fromUser.lastName : caseItem?.toUser.lastName}.
        </div>
        )

        }
    </div>
  )
}

export default TeamupCollaboratedCount
